<template>
  <Modal :id="'cmp-add-checklist'" @cancelled="onCancel">
    <template slot="header"> {{$t('new_checklist')}} </template>

    <template slot="body">
      <!-- <v-text-field :height="5" v-model="checklist_title" label="Checklist Title" /> -->
      <div class="form-group">
        <TextField
          class="m1"
          :id="'checklist_title'"
          required
          v-model="checklist_title"
          isModel
          :placeholder="$t('checklist_title')"
        ></TextField>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel"> {{$t('cancel')}} </button>
      <button class="dt-button v1 s6" @click.stop="addChecklist"> {{$t('add_checklist')}} </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../modal/modal";

export default {
  components: {
    Modal
  },
  data: function() {
    return {
      checklist_title: ""
    };
  },
  methods: {
    addChecklist: function(e) {
      if (this.checklist_title && this.checklist_title.length > 0) {
        this.$emit("ADD_NEW", this.checklist_title);
        this.checklist_title = "";
        this.$emit("CANCEL", false);
      }
    },
    onCancel: function(e) {
      this.$emit("CANCEL", false);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
